import React from "react";
import utils from "utils";
import { message } from "antd";
import api from "utils/api";
import { ArrowRightOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Select,
} from "antd";
import SubmitButton from "../Patient/SubmitButton"
import { CONSTANTS } from "utils/constant";
const placeholder = "Type here...";
class DoctorReferral extends React.Component {  
  constructor(props) {
    super(props);
    this.state = {
    autoNoReferral:!this.props.is_doctor_referral,
    buttonLoading: true
    };
    this.handleSpecialityChange=this.handleSpecialityChange.bind(this)
    this.formReferal = React.createRef();
  }

 
componentDidMount(){

    this.props.formAction(false);
   this.getSpecialityList()
    this.getDoctorReferral()
}
 
getDoctorReferral() {
  this.setState({buttonLoading: false})
  api
    .get_consultation_details({
      app_id: this.props.data.appointment_id,
      type: "doctor_referral",
    })
    .then((response) => {
      let data =
        response.data?.data?.results?.doctor_referral[0]
          ?.referral_comments[0];
      if (data.new_doctor_name) {
        this.setState({
          autoNoReferral: false,
          followup_data: {     
            name: data?.new_doctor_name,
            comments: data?.doctor_comments,
          },
        });
      }
      this.formReferal.current?.setFieldsValue({
        comments: data?.doctor_comments,
        speciality_doctor: data?.new_doctor_name,
        speciality_name : data?.reffered_speciality,
      });
    })
    .catch((err) => {});
}
  getSpecialityList() {
    let data = {
      "appointment_id": this.props.appointment_id
    }
    api.get_speciality_list(data)
      .then((response) => {
        this.setState({ dataSpeciality: response.data })
      })
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.prescriptions !== this.state.prescriptions) {
  //     console.log("updated", this.state.prescriptions)
  //     this.setState({noPrescription: 2})
  //   }
  // }




 



  



  handleDoctorDatesChange(formData) {
    if (!formData) return
    let data = {
      doctor_id: this.props.doc_api_id,
      appointment_date_time: utils.FormatDate(formData, "UTC", "days"),
    };
    api
      .get_doctor_slots(data)
      .then((res) => {
        if (res.data?.status == 200) {
          this.setState({
            doctorAvaliableSlots: res.data?.data.results,
          });
        }
      })
      .catch((err) => { });
    this.formConsultation.current?.resetFields(['consultationTime']);
  }
  handleDoctorSlotsChange(formData) {
    this.setState({
      selectedSlot: formData,
    });
  }
 
  addReferralSubmit(values) {
    if (this.state.newDoctorId == undefined) {
      message.error(`${CONSTANTS.DOCTOR_REFERAL_ERR_MSG}`, ErrorDuration)
      this.props.formAction(false);
      this.setState({buttonLoading: false})
    }
    else {
      let data = {
        "appointment_id": this.props.appointment_id,
        "new_doctor_id": this.state.newDoctorId,
        "comments": values.comments || "",
        "reffered_speciality": this.state.reffered_speciality || "",
      };
      api.create_referral(data)
        .then((response) => {
          if(response.status == 200)
         { this.setState({
            autoNoReferral: false,
            // referalValue: 1
          })

          this.props.formAction(false)
          message.success(response.data.message , ErrorDuration)
          this.setState({buttonLoading: false})
        }
        else
        {
          message.error(response.data.message , ErrorDuration)
          this.setState({buttonLoading: false})
        }
        })
    }
  }
 
  onConsultationTomeChange(time, timeString) {
    // console.log(time, timeString);
  }
  
 
  handleSpecialityChange(value,option) {
    this.formReferal.current?.setFieldsValue({speciality_doctor : null })
    let data = {
      "appointment_id": this.props.data?.appointment_id,
      "specialty_id": value
    }
    api.get_speciality_doctors_list(data)
      .then((response) => {
        this.setState({ dataSpecialityDoctors: response.data , reffered_speciality : option?.children || "", newDoctorId: undefined  })
      })
  }

  render() {
  
    return (
      <div className="video-consultation-wrapper">
      
      <Form
                            name="addReferal"
                            ref={this.formReferal}
                            layout="vertical"
                            initialValues={{ remember: true }}
                            onFinish={(values) => this.addReferralSubmit(values)}
                            onFieldsChange={ ()=>this.props.formAction(true) }
                            autoComplete="off"
                            style={{margin:"0px 10px"}}
                            labelCol={{
                              span: 16,
                            }}
                            wrapperCol={{
                              span: 8,
                            }}
                          >
                            <Row gutter={8}>
                              <Col span={16}>
                                <Row gutter={8}>
                                  <Col span={24} 
                                  // style={{ marginTop: 25 }}
                                  >
                                    
                                      <Row>
                                       
                                          <Col span={24}>
                                            <Form.Item
                                              label={CONSTANTS.SPECIALITY_NAME}
                                              labelAlign="left"
                                              name="speciality_name"
                                              required={true}

                                            >
                                              <Select
                                                placeholder={CONSTANTS.SPECIALITY}
                                                onChange={(value,option) => {this.handleSpecialityChange(value,option)}}
                                               disabled={!this.state.autoNoReferral}
                                                style={{ width: "300px" }}
                                              >
                                                {(this.state?.dataSpeciality?.data || []).map((m, i) => {
                                                  return (
                                                    <Select.Option key={m.specialty_id}
                                                      value={m.specialty_id}
                                                    >
                                                      {m.specialty_name}
                                                    </Select.Option>
                                                  )
                                                })}
                                              </Select>
                                            </Form.Item>
                                          </Col>                                        
                                        <Col span={24}>
                                          <Form.Item
                                            label={CONSTANTS.SPECIALITY_DOCTOR}
                                            labelAlign="left"
                                            name="speciality_doctor"
                                            required={true}
                                          >
                                            <Select
                                              placeholder={CONSTANTS.SELECT_DOCTOR}
                                              onChange={(value) => {this.setState({newDoctorId: value})}}
                                              disabled={!this.state.autoNoReferral}
                                              optionFilterProp="children"
                                              optionLabelProp="label"
                                              style={{ width: "300px" }}

                                            >
                                              {(this.state.dataSpecialityDoctors?.data || []).map((m, i) => {
                                                return (
                                                  <Select.Option key={m.doctor_id}
                                                    value={m.doctor_id} label={m.doctor_name}
                                                  >
                                                    {/* {m.doctor_name} */}
                                                    <div className="option-section">
                                                      <span className="name">{m.doctor_name}</span>
                                                      {m.doctor_languages && (
                                                          <span style={{ display: "inline-block", wordWrap: "break-word",whiteSpace: "normal", color: "#107569"}} className="doctor-specl-regno">
                                                              {` ${m.doctor_languages.join(", ")}`}
                                                          </span>
                                                      )}
                                                    </div>
                                                  </Select.Option>
                                                )
                                              })}
                                            </Select>
                                          </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                          <Form.Item
                                            label={CONSTANTS.COMMENTS}
                                            labelAlign="left"
                                            name="comments"
                                            colon={false}
                                          
                                            
                                          >
                                            <Input.TextArea style={{ minWidth: "300px", minHeight: "50px", }}
                                          placeholder={placeholder} disabled={!this.state.autoNoReferral}  
                                              
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                  </Col>
                                </Row>
                              </Col>
                              <Col
                                        span={24}
                                        className="submit-button-wrapper"
                                        style={{
                                          textAlign: "right",
                                          marginTop: 20,
                                        }}
                                      >
                                        {this.state.autoNoReferral && 
                                        <SubmitButton onClick={e=>{this.setState({buttonLoading: true})}} label={CONSTANTS.SUBMIT} className={"common-btn"} type={"primary"} htmlType={"submit"} loading={this.state.buttonLoading}/>
                                        // <Button className="common-btn"
                                        //   type="primary"
                                        //   shape="round"
                                        //   htmlType="submit"
                                        // >
                                        //   {CONSTANTS.SUBMIT} <ArrowRightOutlined />
                                        // </Button>
                                        }
                                      </Col>
                            </Row>
                          </Form>
      
      </div >
    );
  }
}

export default (DoctorReferral);
// export default withRouter(VideoConsultation);